module.exports = __webpack_public_path__ + "img/vip_background.049df70b.png";